export default {"src":"/_next/static/media/white-star.1651a460.svg","height":17,"width":16};